import { COVAULT_URL_PASSTHRU_KEY } from 'constants/urlPassthru'

export default function(store) {
  return next => action => {
    if (action.type === '@@router/LOCATION_CHANGE') {
      const { router, auth } = store.getState()

      const firstRouteAfterPageload = router.location === null
      const notAuthenticated = !(auth && auth.isAuthenticated)
      const notRedirectingAfterAuthenticating = action.payload.pathname !== '/login/callback'

      if (firstRouteAfterPageload && notAuthenticated && notRedirectingAfterAuthenticating) {
        window.sessionStorage.setItem(COVAULT_URL_PASSTHRU_KEY, `${action.payload.pathname}${action.payload.search}`)
      }
    }

    return next(action)
  }
}
